import { useUserStore } from "@/store";

const useAccess = () => {
  const user = useUserStore((state) => state.currentUser);
  const permissions = useUserStore((state) => state.permissions);
  const isAdmin = !!user?.roles.find((role) => role.name === "admin");

  const getAccess = (expected: string[]): boolean =>
    isAdmin ||
    permissions?.filter(({ name }) => expected.includes(name))?.length ===
      expected.length;

  return {
    getAccess,
    permissions,
    isAdmin,
    currentUser: user
  };
};

export default useAccess;